import { render, staticRenderFns } from "./reports-revoked-certificates.vue?vue&type=template&id=5d741c6f"
import script from "./reports-revoked-certificates.vue?vue&type=script&lang=js"
export * from "./reports-revoked-certificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports